import React from 'react';
import { Popover } from 'reactstrap';
import { popoverModifiers as defaultPopoverModifiers } from 'enums';

const PopoverCompat = ({ modifiers, popoverModifiers, ...rest }) => {
  const resolvedModifiers = modifiers || popoverModifiers || defaultPopoverModifiers;

  return <Popover modifiers={resolvedModifiers} {...rest} />;
};

export default PopoverCompat;
